module.exports = __webpack_public_path__ + "img/mostUsed.dc697e8f.svg";